import React, { useEffect, useState } from 'react';

const Tooltip = ({ isMobile, handleClose }) => {
    const tooltiptop = isMobile ? { top: '77%' } : {}; // desktop positioning CSS se hogi

    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => setFadeIn(true), 100);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className={`tooltip ${fadeIn ? "fade-in" : ""}`} style={tooltiptop}>
            
            {isMobile && (
                <button className="close-btn-tt" onClick={handleClose}>
                    &times;
                </button>
            )}

            <div className="tooltip-content basic-tips">
                <p className="tips-title"><strong>Some basic tips:</strong></p> 
                <ul>
                    <li>Use <strong>specific keywords</strong> (3 min)</li>
                    <li>Keep your <strong>browser updated</strong></li>
                    <li><strong>Allow pop-ups</strong></li>
                    <li>Big results = <strong>slower search</strong></li>
                    <li>MapR uses only <strong>1 cookie</strong></li>
                    <p className="tips-note">(to recognize you on return)</p>
                </ul>
            </div>

        </div>

    );
};

export default Tooltip;
